import { createContext, useState } from 'react'

const BotReplyContext = createContext()

const BotReplyProvider = ({ children }) => {
  const [botReplyState, setBotReplyState] = useState({
    open: false,
    position: null
  })

  const openBotReply = (position = null) =>
    setBotReplyState({ open: true, position })

  const closeBotReply = () =>
    setBotReplyState(prev => ({ ...prev, open: false }))

  return (
    <BotReplyContext.Provider
      value={{ botReplyState, openBotReply, closeBotReply }}
    >
      {children}
    </BotReplyContext.Provider>
  )
}

export { BotReplyContext, BotReplyProvider }
